import React from "react";
import Tooltip from "@mui/material/Tooltip";
import TextsmsIcon from "@mui/icons-material/Textsms";
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';

const ActionsCellEsale = ({
  status,
  row,
  pageName,
  handleClickOpenShowCommunicationHistory,
  handleClickOpenAddCorrespondence,
  handleClickOpenShowCorrespondence
}) => {
  const { allData } = row;
  return (
    <div className="text-xs flex justify-end justify-items-end al-itm-bs">
      <div className="text-gray-500">
        <Tooltip title="Add Correspondence" placement="bottom-end">
          <AddIcon onClick={(event) => handleClickOpenAddCorrespondence(event, allData)} />
        </Tooltip>
      </div>
      <div>
        <Tooltip title="Show Correspondence" placement="bottom">
          <VisibilityIcon onClick={(event) => handleClickOpenShowCorrespondence(event, allData)} />
        </Tooltip>
      </div>
      <div>
        <Tooltip title="Communication History" placement="bottom-end">
          <TextsmsIcon onClick={(event) => handleClickOpenShowCommunicationHistory(event, allData)} />
        </Tooltip>
      </div>

    </div>
  );
};

export default ActionsCellEsale;
